import Vue from 'vue'
import Vuex from 'vuex'

import api from './modules/api'
import authorization from './modules/authorization'
import user from './modules/user'
import gsa from './modules/gsa'
import refs from './modules/refs'
import errors from './modules/errors'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    api,
    authorization,
    user,
    gsa,
    refs,
    errors
  }
})
